const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://172.30.1.101:5000/' : 'https://api-m3guo.17m3.com/';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:8080/' : 'https://www.m3guo.com/activity/202309/ck134b2f5/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'index.html';

const activityTime = '9月1日-9月28日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const tipsImg = ['KB55', 'KB56', 'KR26', 'KR30', 'KW23', 'LC09', 'LJ06', 'LP51', 'ME02', 'Y552', 'Y819', 'Y867', 'KD85', 'LP59', 'MJ74', ];

let search_code = getQueryVariable('code') ? ('?code=' + getQueryVariable('code')) : '';
let add = getQueryVariable('code') ? '&' : '?';
let search_key = getQueryVariable('key') ? (add + 'key=' + getQueryVariable('key')) : '';

const wx_share_text = {
  title: '疯狂吉娃辛宪英登场', // 分享标题
  desc: '鸡王争霸第7期', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202309/ck/sns.jpg', // 分享图标   
}

const issn = '230903';

const ajax_url_map = {
  login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  free : host + 'api/Login/KouDai',
  logininfo : host + 'api/user/getLoginInfo',
  userinfo : host + 'api/chicken/getUserInfo',
  queryplayer : host + 'api/user/GetNickName',
  bind : host + 'api/user/bind',
  task : host + 'api/userTask/taskList',//任务列表
  apply: host + 'api/chicken/commit',//一键领取 1:一键领取 2:枪王福利宝箱 3:枪王升级宝箱 4:回馈奖励，大吉大利鸡王宝藏
  mplat : host + 'api/login/mplat',//梦平台免登录
  buy : host + 'api/chicken/buy',//购买 1:经验,2:599鸡王,8:加码礼包1,16:加码礼包2,32:鸡王系列换装包,64:枪王之王特惠包
  skin : host + 'api/chicken/querySkin',//皮肤查询
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
  rank : 'https://ssl-dataapi.17m3.com/index.php/interfaceManage/interfaceForCommonUse?uniq_id=qgeyz3',//排行榜
  queryscore : host + 'api/chicken/queryScore',//军威值查询
}

const EXP = [10000,20000,30000,40000];

const level = [1000, 2500, 4500, 7000, 10000, 11000, 12500, 14500, 17000, 20000, 21000, 22500, 24500, 27000, 30000, 31000, 32500, 34500, 37000, 40000,];

const end = ['9月7日','9月14日','9月21日','9月28日'];

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
},
{
  "id": 22,
  "name": "逍遥津(wegame3)"
}, {
  "id": 23,
  "name": "单刀赴会"
}
, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 22) {
    area = '逍遥津';
  }else if (num == 23) {
    area = '单刀赴会';
  }else if (num == 100 || num == 101) {
        area = '测试大区';
  }

  return area;
}


export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    activityTime,
    tipsImg,
    wx_share_text,
    EXP,
    level,
    end,
    queryArea,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js